// extracted by mini-css-extract-plugin
module.exports = {"cashierExpressButtonsContainer":"BY2gHV"};